import { Grid } from '@mui/material';
import {
  MobileChecklist,
  MobileUpsellCards,
  MobileUpsellFooter,
  MobileUpsellHeader,
  MobileUpsellSubtitle,
  MobileUpsellTitle,
} from './components';
import { useEffect, useRef, useState } from 'react';

interface MobileUpsellContentProps {
  advicePrice: string;
  openDoc: (description: 'Terms of Service' | 'Privacy Policy') => Promise<void>;
  onUpgradeToPremium: () => Promise<void>;
  handleClose: () => void;
}
const MobileUpsellContent: React.FC<MobileUpsellContentProps> = ({
  advicePrice,
  openDoc,
  onUpgradeToPremium,
  handleClose,
}) => {
  const footerRef = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState<{ width: number; height: number }>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    if (footerRef.current) {
      setDimensions({
        width: footerRef.current.offsetWidth,
        height: footerRef.current.offsetHeight,
      });
    }
  }, []);

  return (
    <>
      <Grid
        className='content-view'
        gridArea='content'
        sx={{
          padding: '20px',
          overflow: 'scroll',
          height: `calc(100% - ${dimensions.height}px)`,
          width: '100%',
          textAlign: 'center',
        }}>
        <MobileUpsellHeader handleClose={handleClose} />
        <MobileUpsellTitle />
        <MobileUpsellSubtitle />
        <MobileUpsellCards />
        <MobileChecklist />
      </Grid>
      <MobileUpsellFooter
        advicePrice={advicePrice}
        openDoc={openDoc}
        onUpgradeToPremium={onUpgradeToPremium}
        footerRef={footerRef}
      />
    </>
  );
};

export default MobileUpsellContent;
